<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item mb-1"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >

    <b-link
      v-bind="linkProps"
      class="d-flex align-items-start"
    >
      <div v-if="item.icon === 'overview.svg'">
        <svg
          viewBox="0 0 27 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="icon"
            d="M11.2273 15.7727H15.7727M20.8864 21.4545C21.5579 21.4545 22.2229 21.3223 22.8433 21.0653C23.4637 20.8083 24.0274 20.4316 24.5022 19.9568C24.9771 19.4819 25.3538 18.9182 25.6107 18.2978C25.8677 17.6774 26 17.0124 26 16.3409C26 15.6694 25.8677 15.0044 25.6107 14.384C25.3538 13.7636 24.9771 13.1999 24.5022 12.725C24.0274 12.2502 23.4637 11.8735 22.8433 11.6165C22.2229 11.3595 21.5579 11.2273 20.8864 11.2273C19.5301 11.2273 18.2295 11.766 17.2705 12.725C16.3115 13.684 15.7727 14.9847 15.7727 16.3409C15.7727 17.6971 16.3115 18.9978 17.2705 19.9568C18.2295 20.9158 19.5301 21.4545 20.8864 21.4545V21.4545ZM11.2273 5.54545H15.7727H11.2273ZM1.56818 14.0682C1.56818 14.0682 6.11364 3.27273 6.68182 2.13636C7.25 1 8.38636 1 8.95455 1C9.52273 1 11.2273 1 11.2273 3.27273V15.7727L1.56818 14.0682ZM6.11364 21.4545C5.4421 21.4545 4.77715 21.3223 4.15673 21.0653C3.53632 20.8083 2.97259 20.4316 2.49775 19.9568C2.0229 19.4819 1.64624 18.9182 1.38925 18.2978C1.13227 17.6774 1 17.0124 1 16.3409C1 15.6694 1.13227 15.0044 1.38925 14.384C1.64624 13.7636 2.0229 13.1999 2.49775 12.725C2.97259 12.2502 3.53632 11.8735 4.15673 11.6165C4.77715 11.3595 5.4421 11.2273 6.11364 11.2273C7.46986 11.2273 8.77053 11.766 9.72952 12.725C10.6885 13.684 11.2273 14.9847 11.2273 16.3409C11.2273 17.6971 10.6885 18.9978 9.72952 19.9568C8.77053 20.9158 7.46986 21.4545 6.11364 21.4545V21.4545ZM25.4318 14.0682C25.4318 14.0682 20.8864 3.27273 20.3182 2.13636C19.75 1 18.6136 1 18.0455 1C17.4773 1 15.7727 1 15.7727 3.27273V15.7727L25.4318 14.0682Z"
            stroke="#CBCBCB"
            stroke-width="2"
          />
        </svg>
      </div>
      <div v-else-if="item.icon === 'projects.svg'">
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="icon"
            d="M9.36364 15.6364V24H1V15.6364H9.36364ZM24 15.6364V24H15.6364V15.6364H24ZM9.36364 1V9.36364H1V1H9.36364ZM24 1V9.36364H15.6364V1H24Z"
            stroke="#C4C4C4"
            stroke-width="2"
          />
        </svg>
      </div>
      <div v-else-if="item.icon === 'inventory.svg'">
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.1478 0.134295C12.0187 0.206968 9.27611 2.09666 6.05303 4.33356C2.07492 7.09436 0.153726 8.48991 0.0708466 8.67849C-0.0905732 9.04624 0.0302747 9.47821 0.367868 9.74022C0.742561 10.0309 1.01637 10.0067 1.5886 9.63212L2.07677 9.31253L2.13101 16.0514L2.18525 22.7901L2.42695 23.0286C2.7615 23.3585 3.38928 23.354 3.66374 23.0196C3.8577 22.7834 3.86671 22.4439 3.86671 15.4105V8.04863L8.16527 5.06735C10.5294 3.42756 12.4854 2.09324 12.512 2.10223C12.5385 2.11111 14.5077 3.45967 16.8882 5.09903L21.2163 8.07956L21.22 15.3783L21.2237 22.677L21.4808 22.9719C21.8134 23.3534 22.4159 23.3797 22.7719 23.0286L23.0136 22.7902L23.0678 16.0941L23.1221 9.39794L23.3933 9.60697C23.8091 9.92752 24.1056 9.9821 24.4574 9.80261C24.8231 9.61606 25.0738 9.10607 24.9804 8.73886C24.9327 8.55177 23.4005 7.43568 19.1914 4.52268C12.4959 -0.111336 12.6582 -0.00152411 12.5029 0.000509433C12.4367 0.00136566 12.2769 0.0615157 12.1478 0.134295ZM5.70047 9.39066C5.63473 9.56084 5.60154 10.2851 5.62171 11.1072C5.64927 12.228 5.69114 12.5509 5.81937 12.6307C6.03134 12.7627 8.97031 12.7627 9.18228 12.6307C9.39024 12.5013 9.48646 9.67118 9.29499 9.3182C9.18119 9.10843 9.08334 9.09633 7.49431 9.09633H5.81394L5.70047 9.39066ZM6.11769 13.8762C5.64721 13.9561 5.58288 14.212 5.6215 15.8511C5.64937 17.036 5.69038 17.3668 5.81937 17.447C6.03134 17.579 8.97031 17.579 9.18228 17.447C9.3118 17.3664 9.35183 17.0336 9.37852 15.8164C9.423 13.7895 9.49427 13.8761 7.7576 13.8477C7.01971 13.8356 6.28171 13.8484 6.11769 13.8762ZM11.2977 13.8778C10.833 14.0017 10.8095 14.0906 10.8095 15.7238C10.8095 16.8029 10.8503 17.335 10.9397 17.4232C11.1214 17.6024 14.186 17.6024 14.3677 17.4232C14.4571 17.335 14.4978 16.8029 14.4978 15.7238C14.4978 14.3935 14.4704 14.1304 14.3185 14.0059C14.1349 13.8556 11.7594 13.7548 11.2977 13.8778ZM6.09057 18.6918C5.66445 18.8002 5.6024 19.029 5.6024 20.4916C5.6024 22.4466 5.52397 22.3683 7.47988 22.3663C8.32669 22.3653 9.09278 22.3191 9.18228 22.2633C9.3118 22.1827 9.35183 21.8499 9.37852 20.6327C9.42332 18.5913 9.49969 18.6811 7.69945 18.6559C6.9339 18.6452 6.2099 18.6614 6.09057 18.6918ZM11.2977 18.6952C10.8334 18.8167 10.8095 18.9067 10.8095 20.54C10.8095 21.6192 10.8503 22.1512 10.9397 22.2394C11.1214 22.4187 14.186 22.4187 14.3677 22.2394C14.4571 22.1512 14.4978 21.6192 14.4978 20.54C14.4978 19.2109 14.4703 18.9466 14.3189 18.8222C14.1364 18.6725 11.7654 18.5727 11.2977 18.6952ZM16.3633 18.693C15.9952 18.77 15.9081 19.1321 15.9081 20.5851C15.9081 22.4346 15.8372 22.3679 17.8049 22.3679C19.0776 22.3679 19.3953 22.3369 19.5345 22.1997C19.6729 22.0632 19.7049 21.7551 19.7049 20.5612C19.7049 18.5951 19.7809 18.6801 18.0051 18.6582C17.2396 18.6486 16.5007 18.6644 16.3633 18.693Z"
            fill="#CBCBCB"
          />
        </svg>
      </div>
      <div v-else-if="item.icon === 'circle'">
        <feather-icon icon="CircleIcon" />
      </div>
      <div v-else-if="item.icon === 'products.svg'">
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="icon"
            d="M3.75 22.5C4.44036 22.5 5 21.9404 5 21.25C5 20.5596 4.44036 20 3.75 20C3.05964 20 2.5 20.5596 2.5 21.25C2.5 21.9404 3.05964 22.5 3.75 22.5Z"
            fill="#C4C4C4"
          />
          <path
            class="icon"
            d="M2.5 2.5H5V13.75H2.5V2.5Z"
            fill="#C4C4C4"
          />
          <path
            class="icon"
            d="M6.25 0H1.25C0.918479 0 0.600537 0.131696 0.366116 0.366116C0.131696 0.600537 0 0.918479 0 1.25V23.75C0 24.0815 0.131696 24.3995 0.366116 24.6339C0.600537 24.8683 0.918479 25 1.25 25H6.25C6.58152 25 6.89946 24.8683 7.13388 24.6339C7.3683 24.3995 7.5 24.0815 7.5 23.75V1.25C7.5 0.918479 7.3683 0.600537 7.13388 0.366116C6.89946 0.131696 6.58152 0 6.25 0ZM6.25 23.75H1.25V1.25H6.25V23.75Z"
            fill="#C4C4C4"
          />
          <path
            class="icon"
            d="M12.5 22.5C13.1904 22.5 13.75 21.9404 13.75 21.25C13.75 20.5596 13.1904 20 12.5 20C11.8096 20 11.25 20.5596 11.25 21.25C11.25 21.9404 11.8096 22.5 12.5 22.5Z"
            fill="#C4C4C4"
          />
          <path
            class="icon"
            d="M11.25 2.5H13.75V13.75H11.25V2.5Z"
            fill="#C4C4C4"
          />
          <path
            class="icon"
            d="M15 0H10C9.66848 0 9.35054 0.131696 9.11612 0.366116C8.8817 0.600537 8.75 0.918479 8.75 1.25V23.75C8.75 24.0815 8.8817 24.3995 9.11612 24.6339C9.35054 24.8683 9.66848 25 10 25H15C15.3315 25 15.6495 24.8683 15.8839 24.6339C16.1183 24.3995 16.25 24.0815 16.25 23.75V1.25C16.25 0.918479 16.1183 0.600537 15.8839 0.366116C15.6495 0.131696 15.3315 0 15 0ZM15 23.75H10V1.25H15V23.75Z"
            fill="#C4C4C4"
          />
          <path
            class="icon"
            d="M21.25 22.5C21.9404 22.5 22.5 21.9404 22.5 21.25C22.5 20.5596 21.9404 20 21.25 20C20.5596 20 20 20.5596 20 21.25C20 21.9404 20.5596 22.5 21.25 22.5Z"
            fill="#C4C4C4"
          />
          <path
            class="icon"
            d="M20 2.5H22.5V13.75H20V2.5Z"
            fill="#C4C4C4"
          />
          <path
            class="icon"
            d="M23.75 0H18.75C18.4185 0 18.1005 0.131696 17.8661 0.366116C17.6317 0.600537 17.5 0.918479 17.5 1.25V23.75C17.5 24.0815 17.6317 24.3995 17.8661 24.6339C18.1005 24.8683 18.4185 25 18.75 25H23.75C24.0815 25 24.3995 24.8683 24.6339 24.6339C24.8683 24.3995 25 24.0815 25 23.75V1.25C25 0.918479 24.8683 0.600537 24.6339 0.366116C24.3995 0.131696 24.0815 0 23.75 0ZM23.75 23.75H18.75V1.25H23.75V23.75Z"
            fill="#C4C4C4"
          />
        </svg>
      </div>
      <div v-else-if="item.icon === 'clients.svg'">
        <svg
          width="25"
          height="29"
          viewBox="0 0 25 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="icon"
            d="M5.83333 8.33333C5.61232 8.33333 5.40036 8.42113 5.24408 8.57741C5.0878 8.73369 5 8.94565 5 9.16667C5 9.38768 5.0878 9.59964 5.24408 9.75592C5.40036 9.9122 5.61232 10 5.83333 10H14.1667C14.3877 10 14.5996 9.9122 14.7559 9.75592C14.9122 9.59964 15 9.38768 15 9.16667C15 8.94565 14.9122 8.73369 14.7559 8.57741C14.5996 8.42113 14.3877 8.33333 14.1667 8.33333H5.83333ZM5 14.1667C5 13.9457 5.0878 13.7337 5.24408 13.5774C5.40036 13.4211 5.61232 13.3333 5.83333 13.3333H13.6167C13.4333 13.855 13.3333 14.4167 13.3333 15H5.83333C5.61232 15 5.40036 14.9122 5.24408 14.7559C5.0878 14.5996 5 14.3877 5 14.1667ZM18.3333 4.16667V10C18.9167 10 19.4783 10.1 20 10.285V4.16667C20 3.50363 19.7366 2.86774 19.2678 2.3989C18.7989 1.93006 18.163 1.66667 17.5 1.66667H16.6667V0.833333C16.6667 0.61232 16.5789 0.400358 16.4226 0.244078C16.2663 0.0877975 16.0543 0 15.8333 0C15.6123 0 15.4004 0.0877975 15.2441 0.244078C15.0878 0.400358 15 0.61232 15 0.833333V1.66667H10.8333V0.833333C10.8333 0.61232 10.7455 0.400358 10.5893 0.244078C10.433 0.0877975 10.221 0 10 0C9.77899 0 9.56702 0.0877975 9.41074 0.244078C9.25446 0.400358 9.16667 0.61232 9.16667 0.833333V1.66667H5V0.833333C5 0.61232 4.9122 0.400358 4.75592 0.244078C4.59964 0.0877975 4.38768 0 4.16667 0C3.94565 0 3.73369 0.0877975 3.57741 0.244078C3.42113 0.400358 3.33333 0.61232 3.33333 0.833333V1.66667H2.5C1.83696 1.66667 1.20107 1.93006 0.732233 2.3989C0.263392 2.86774 0 3.50363 0 4.16667V24.1667C0 24.8297 0.263392 25.4656 0.732233 25.9344C1.20107 26.4033 1.83696 26.6667 2.5 26.6667H11.25C10.8951 26.1519 10.6119 25.5912 10.4083 25H2.5C2.27899 25 2.06702 24.9122 1.91074 24.7559C1.75446 24.5996 1.66667 24.3877 1.66667 24.1667V4.16667C1.66667 3.94565 1.75446 3.73369 1.91074 3.57741C2.06702 3.42113 2.27899 3.33333 2.5 3.33333H17.5C17.721 3.33333 17.933 3.42113 18.0893 3.57741C18.2455 3.73369 18.3333 3.94565 18.3333 4.16667ZM5.83333 18.3333C5.61232 18.3333 5.40036 18.4211 5.24408 18.5774C5.0878 18.7337 5 18.9457 5 19.1667C5 19.3877 5.0878 19.5996 5.24408 19.7559C5.40036 19.9122 5.61232 20 5.83333 20H9.16667C9.38768 20 9.59964 19.9122 9.75592 19.7559C9.9122 19.5996 10 19.3877 10 19.1667C10 18.9457 9.9122 18.7337 9.75592 18.5774C9.59964 18.4211 9.38768 18.3333 9.16667 18.3333H5.83333ZM21.6667 15C21.681 14.5536 21.6055 14.1089 21.4446 13.6923C21.2838 13.2756 21.0408 12.8956 20.7302 12.5747C20.4196 12.2538 20.0477 11.9986 19.6365 11.8242C19.2253 11.6498 18.7833 11.5598 18.3367 11.5596C17.8901 11.5594 17.448 11.6489 17.0367 11.8229C16.6253 11.9968 16.2532 12.2517 15.9422 12.5723C15.6313 12.8929 15.388 13.2727 15.2267 13.6892C15.0654 14.1056 14.9894 14.5503 15.0033 14.9967C15.0303 15.8621 15.3929 16.683 16.0144 17.2858C16.6359 17.8886 17.4676 18.2259 18.3334 18.2263C19.1992 18.2267 20.0312 17.8903 20.6533 17.2881C21.2754 16.686 21.6389 15.8654 21.6667 15ZM11.6667 22.5C11.6667 22.7867 11.6833 23.065 11.72 23.3333C11.8846 24.7219 12.5915 25.989 13.6867 26.8583C14.9217 27.85 16.5783 28.3333 18.3333 28.3333C20.0883 28.3333 21.745 27.85 22.98 26.8583C24.2333 25.85 25 24.36 25 22.5C25 21.837 24.7366 21.2011 24.2678 20.7322C23.7989 20.2634 23.163 20 22.5 20H14.1667C13.5036 20 12.8677 20.2634 12.3989 20.7322C11.9301 21.2011 11.6667 21.837 11.6667 22.5Z"
            fill="#CBCBCB"
          />
        </svg>
      </div>
      <div v-else-if="item.icon === 'reports.svg'">
        <svg
          width="27"
          height="32"
          viewBox="0 0 27 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="icon"
            d="M26 8.35294L13.5 1L1 8.35294V23.0588L13.5 30.4118L26 23.0588V8.35294Z"
            stroke="#C4C4C4"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            class="icon"
            d="M13.5 14.2353V20.1176"
            stroke="#C4C4C4"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            class="icon"
            d="M19.3824 11.2941V20.1177"
            stroke="#C4C4C4"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            class="icon"
            d="M7.61761 17.1765V20.1177"
            stroke="#C4C4C4"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

      </div>
      <div v-else-if="item.icon === 'messages.svg'">
        <div class="">
          <!-- <div class="side-bar-icon-cont"> -->
          <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="icon"
            d="M11.1607 12.4998C11.1607 12.855 11.3018 13.1957 11.553 13.4468C11.8042 13.698 12.1448 13.8391 12.5 13.8391C12.8552 13.8391 13.1958 13.698 13.447 13.4468C13.6982 13.1957 13.8393 12.855 13.8393 12.4998C13.8393 12.1446 13.6982 11.804 13.447 11.5528C13.1958 11.3017 12.8552 11.1606 12.5 11.1606C12.1448 11.1606 11.8042 11.3017 11.553 11.5528C11.3018 11.804 11.1607 12.1446 11.1607 12.4998ZM16.741 12.4998C16.741 12.855 16.8821 13.1957 17.1333 13.4468C17.3844 13.698 17.7251 13.8391 18.0803 13.8391C18.4355 13.8391 18.7761 13.698 19.0273 13.4468C19.2785 13.1957 19.4196 12.855 19.4196 12.4998C19.4196 12.1446 19.2785 11.804 19.0273 11.5528C18.7761 11.3017 18.4355 11.1606 18.0803 11.1606C17.7251 11.1606 17.3844 11.3017 17.1333 11.5528C16.8821 11.804 16.741 12.1446 16.741 12.4998ZM5.58045 12.4998C5.58045 12.855 5.72155 13.1957 5.97271 13.4468C6.22387 13.698 6.56452 13.8391 6.91971 13.8391C7.27491 13.8391 7.61556 13.698 7.86672 13.4468C8.11788 13.1957 8.25898 12.855 8.25898 12.4998C8.25898 12.1446 8.11788 11.804 7.86672 11.5528C7.61556 11.3017 7.27491 11.1606 6.91971 11.1606C6.56452 11.1606 6.22387 11.3017 5.97271 11.5528C5.72155 11.804 5.58045 12.1446 5.58045 12.4998ZM24.0289 7.65615C23.3983 6.15785 22.4943 4.813 21.342 3.65788C20.1977 2.50945 18.8393 1.59658 17.3437 0.97097C15.8091 0.326447 14.1797 0 12.5 0H12.4442C10.7534 0.00837043 9.11556 0.343188 7.5754 1.00166C6.0926 1.63369 4.74693 2.54817 3.61339 3.69415C2.47223 4.84648 1.57659 6.18575 0.957178 7.67848C0.315445 9.22422 -0.00821214 10.8676 0.000158292 12.5584C0.00962595 14.4961 0.468043 16.4052 1.33943 18.1359V22.377C1.33943 22.7173 1.47465 23.0438 1.71535 23.2845C1.95604 23.5252 2.2825 23.6604 2.62289 23.6604H6.8667C8.59741 24.5318 10.5065 24.9902 12.4442 24.9997H12.5028C14.1741 24.9997 15.7952 24.676 17.3214 24.0427C18.8094 23.4245 20.1628 22.5223 21.3057 21.3865C22.458 20.2453 23.3648 18.9116 23.9982 17.4244C24.6567 15.8843 24.9915 14.2465 24.9998 12.5556C25.0082 10.8564 24.679 9.20747 24.0289 7.65615ZM19.813 19.877C17.8571 21.8133 15.2622 22.8792 12.5 22.8792H12.4526C10.7701 22.8708 9.09882 22.4523 7.62283 21.6655L7.38846 21.5399H3.45994V17.6114L3.33438 17.377C2.54756 15.901 2.12904 14.2297 2.12067 12.5473C2.10951 9.7655 3.17255 7.15393 5.12286 5.18688C7.07038 3.21983 9.67359 2.13167 12.4554 2.12051H12.5028C13.8979 2.12051 15.2511 2.39115 16.5262 2.92686C17.7706 3.44862 18.8866 4.19917 19.8464 5.15898C20.8035 6.11599 21.5568 7.23484 22.0786 8.47925C22.6199 9.76829 22.8905 11.1355 22.8849 12.5473C22.8682 15.3263 21.7772 17.9295 19.813 19.877Z"
            fill="#C4C4C4"
          />
        </svg>
        </div>
       
      </div>
      <div v-else-if="item.icon === 'account.svg'">
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="icon-fill"
            d="M12.5 0C5.6 0 0 5.6 0 12.5C0 19.4 5.6 25 12.5 25C19.4 25 25 19.4 25 12.5C25 5.6 19.4 0 12.5 0ZM12.5 3.75C14.575 3.75 16.25 5.425 16.25 7.5C16.25 9.575 14.575 11.25 12.5 11.25C10.425 11.25 8.75 9.575 8.75 7.5C8.75 5.425 10.425 3.75 12.5 3.75ZM12.5 21.5C11.0148 21.5 9.55273 21.1325 8.2441 20.4302C6.93547 19.7279 5.82097 18.7126 5 17.475C5.0375 14.9875 10 13.625 12.5 13.625C14.9875 13.625 19.9625 14.9875 20 17.475C19.179 18.7126 18.0645 19.7279 16.7559 20.4302C15.4473 21.1325 13.9852 21.5 12.5 21.5Z"
            fill="#C4C4C4"
          />
        </svg>
      </div>
      <span class="menu-title text-truncate ml-3">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
  
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
    // BImg,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },

}
</script>

<style scoped>
[dir=ltr] .main-menu.menu-light .navigation > li.active > a {
  background: none;
}
[dir] .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu:not(.expanded) .navigation li.active a {
  background: none;
}
[dir] .main-menu.menu-light .navigation > li.active > a {
  box-shadow: none;
  color: #4D6D8A;
}
.main-menu.menu-light .navigation > li.active {
  border-left: 3px solid #4D6D8A;
}

[dir] .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu:not(.expanded) .navigation li.active a .icon {
  stroke: #4D6D8A;
}
[dir] .vertical-layout.vertical-menu-modern.menu-collapsed .main-menu:not(.expanded) .navigation li.active a .icon-fill {
  fill: #4D6D8A;
}

.side-bar-icon-cont{
  background-color: rgba(226, 236, 249, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 66px;
  width: 66px;
  border-radius: 100px;
}
</style>
